import {
  EMAIL_PROVIDER_LOADING,
  EMAIL_PROVIDER_SUCCESS,
  EMAIL_PROVIDER_REJECTED,
} from '../actions/email_provider'

const initialState = {
  loading: false,
  fulfilled: false,
  rejected: false,
  provider: null,
  error: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case EMAIL_PROVIDER_LOADING:
      return {
        ...state,
        loading: true,
        fulfilled: false,
        rejected: false,
        provider: null,
        error: null
      }

    case EMAIL_PROVIDER_SUCCESS:
      return {
        ...state,
        loading: false,
        fulfilled: true,
        rejected: false,
        provider: action.payload,
        error: null
      }

    case EMAIL_PROVIDER_REJECTED:
      return {
        ...state,
        loading: false,
        fulfilled: false,
        rejected: true,
        provider: null,
        error: action.payload,
      }

    default:
      return state
  }
}
